import {z} from 'zod';

/** The durable provisioning worker owns progress; no guest call is needed to read it. */
export const AccountPreparationSchema = z.object({
  state: z.enum(['pending', 'running', 'ready', 'error']),
  phase: z.enum(['server', 'team', 'ready']),
  error: z.object({name: z.string(), message: z.string(), stack: z.string().optional(), cause: z.unknown().optional()}).passthrough().nullable(),
}).strict();
export type AccountPreparation = z.infer<typeof AccountPreparationSchema>;
